import gql from 'graphql-tag';
import { kmsClient } from 'api';
import { useMutation } from '@apollo/react-hooks';
import { CreatePerformanceRules, CreatePerformanceRulesVariables } from './__generated__/CreatePerformanceRules';

const CREATE_PERFORMANCE_RULES_MUTATION = gql`
  mutation CreatePerformanceRulesMutation($input: RulesInput!) {
    createPerformanceRules(input: $input) {
      performanceRules {
        id
        name
        level
        evaluationSpec
        status
        createdBy
        triggered
        executionSpec
        campaign {
          id
        }
        triggeredAt
        articleIds
      }
      errors
    }
  }
`;

export const useCreatePerformanceRulesMutation = () => {
  return useMutation<CreatePerformanceRules, CreatePerformanceRulesVariables>(CREATE_PERFORMANCE_RULES_MUTATION, {
    client: kmsClient
  });
};
